import { render, staticRenderFns } from "./vehicleList.vue?vue&type=template&id=449771d2&scoped=true"
import script from "./vehicleList.vue?vue&type=script&lang=js"
export * from "./vehicleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449771d2",
  null
  
)

export default component.exports